/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-autofocus */
/* eslint-disable jsx-a11y/media-has-caption */
import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useTheme } from '@mui/material/styles';
import { Card, CardContent, Typography, Button, IconButton, Box, LinearProgress, Avatar, Tooltip } from '@mui/material';
import { FiX, FiImage, FiMic, FiFile, FiPlus, FiUpload, FiEdit3, FiTrash2, FiPlay } from 'react-icons/fi';
import { RiUploadCloud2Line } from 'react-icons/ri';
import axios from 'lib/axios';
import { useDispatch } from 'react-redux';
import { activeLoader } from 'store/reducers/loaderSlice';
import { toast } from 'sonner';

const NewsModal = ({ setOpenEditor, news, content, user, setNewsList, setOpenOption, showSnack }) => {
    const theme = useTheme();
    const imageInput = useRef(null);
    const textInput = useRef(null);
    const pdfInput = useRef(null);
    const audioInput = useRef(null);
    const [text, setText] = useState(content || '');
    const [openImageUploader, setOpenImageUploader] = useState(news?.image?.length > 0 || news?.video?.length > 0 || false);
    const [openPdfUploader, setOpenPdfUploader] = useState(news?.files?.length > 0 || false);
    const [openAudioUploader, setOpenAudioUploader] = useState(news?.audio?.length > 0 || false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [processing, setProcessing] = useState(false);
    const [validatorMessage, setValidatorMessage] = useState([]);
    const dispatch = useDispatch();

    // New files
    const [postImages, setPostImages] = useState([]);
    const [postAudios, setPostAudios] = useState([]);
    const [postPdfs, setPostPdfs] = useState([]);
    const [postPdfNames, setPostPdfNames] = useState([]);
    const [postMediaData, setPostMediaData] = useState([]);
    const [postaudiosData, setPostaudiosData] = useState([]);
    const [postPdfsData, setPostPdfsData] = useState([]);
    const [postAudioFile, setPostAudioFile] = useState([]);
    const [postMediaFile, setPostMediaFile] = useState([]);

    // Existing files
    const [existingpostImages, setExistingPostImages] = useState(news?.image || []);
    const [existingpostAudios, setExistingpostAudios] = useState(news?.audio || []);
    const [existingpostPdfs, setExistingpostPdfs] = useState(news?.files || []);
    const [existingpostVideos, setExistingpostVideos] = useState(news?.video || []);

    const submitUrl = news ? '/news/update' : '/news';
    const title = news ? 'Edit' : 'Create';

    const toBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });

    const convertMedia = async () => {
        Array.from(imageInput.current.files).forEach(async (f) => {
            if (f.size < 52453290) {
                const file = await toBase64(f);
                const url = URL.createObjectURL(f);
                setPostMediaData((postMediaData) => [...postMediaData, file]);
                setPostMediaFile((postMediaFile) => [...postMediaFile, f]);
                setPostImages((postImages) => [...postImages, url]);
            } else {
                alert('Size Must Be Smaller Than 50MB');
            }
        });
    };

    const convertAudio = async () => {
        Array.from(audioInput.current.files).forEach(async (f) => {
            if (f.size < 52453290) {
                const file = await toBase64(f);
                const url = URL.createObjectURL(f);
                setPostaudiosData((prev) => [...prev, file]);
                setPostAudioFile((prev) => [...prev, f]);
                setPostAudios((prev) => [...prev, url]);
            } else {
                alert('Size Must Be Smaller Than 50MB');
            }
        });
    };

    const convertPdf = async () => {
        Array.from(pdfInput.current.files).forEach(async (f) => {
            if (f.size < 52453290) {
                const file = f;
                const url = URL.createObjectURL(f);
                setPostPdfsData([...postPdfsData, file]);
                setPostPdfs([...postPdfs, url]);
                setPostPdfNames([...postPdfNames, f.name]);
            } else {
                alert('Size Must Be Smaller Than 50MB');
            }
        });
    };

    const removeMediaFile = (index) => {
        if (postImages[index]) {
            URL.revokeObjectURL(postImages[index]);
        }
        setPostImages((prev) => prev.filter((_, i) => i !== index));
        setPostMediaData((prev) => prev.filter((_, i) => i !== index));
        setPostMediaFile((prev) => prev.filter((_, i) => i !== index));
    };

    const removeAudioFile = (index) => {
        if (postAudios[index]) {
            URL.revokeObjectURL(postAudios[index]);
        }
        setPostAudios((prev) => prev.filter((_, i) => i !== index));
        setPostaudiosData((prev) => prev.filter((_, i) => i !== index));
        setPostAudioFile((prev) => prev.filter((_, i) => i !== index));
    };

    const removePdfFile = (index) => {
        if (postPdfs[index]) {
            URL.revokeObjectURL(postPdfs[index]);
        }
        setPostPdfs((prev) => prev.filter((_, i) => i !== index));
        setPostPdfNames((prev) => prev.filter((_, i) => i !== index));
        setPostPdfsData((prev) => prev.filter((_, i) => i !== index));
    };

    const removeExistingImage = (index) => {
        setExistingPostImages((prev) => prev.filter((_, i) => i !== index));
    };

    const removeExistingVideo = (index) => {
        setExistingpostVideos((prev) => prev.filter((_, i) => i !== index));
    };

    const removeExistingAudio = (index) => {
        setExistingpostAudios((prev) => prev.filter((_, i) => i !== index));
    };

    const removeExistingPdf = (index) => {
        setExistingpostPdfs((prev) => prev.filter((_, i) => i !== index));
    };

    const handleClose = useCallback(() => {
        // Clean up object URLs
        postImages.forEach((url) => {
            if (url) URL.revokeObjectURL(url);
        });
        postAudios.forEach((url) => {
            if (url) URL.revokeObjectURL(url);
        });
        postPdfs.forEach((url) => {
            if (url) URL.revokeObjectURL(url);
        });

        setOpenEditor(false);
        if (setOpenOption) setOpenOption(false);
        setText('');
        setOpenImageUploader(false);
        setOpenPdfUploader(false);
        setOpenAudioUploader(false);
        setPostImages([]);
        setPostAudios([]);
        setPostaudiosData([]);
        setPostMediaData([]);
        setPostPdfs([]);
        setPostPdfNames([]);
        setPostPdfsData([]);
        setPostAudioFile([]);
        setPostMediaFile([]);
        setValidatorMessage([]);
        setUploadProgress(0);
        setProcessing(false);
    }, [postImages, postAudios, postPdfs, setOpenEditor, setOpenOption]);

    const submitRequest = async () => {
        if (text.trim() === '') {
            setValidatorMessage([
                {
                    field: 'content',
                    message: 'News content is required'
                }
            ]);
            return;
        }

        try {
            setProcessing(true);
            setUploadProgress(0);

            const formData = new FormData();
            if (news) {
                formData.append('news_id', news.news_id);
            }
            formData.append('content', text);

            // Media
            formData.append('image_exist', existingpostImages.length > 0);
            formData.append('new_image_exist', postMediaData.length > 0);
            formData.append('old_images', JSON.stringify(existingpostImages));

            // Video
            formData.append('video_exist', existingpostVideos.length > 0);
            formData.append('old_videos', JSON.stringify(existingpostVideos));

            // Audio
            formData.append('audio_exist', existingpostAudios.length > 0);
            formData.append('new_audio_exist', postaudiosData.length > 0);
            formData.append('old_audios', JSON.stringify(existingpostAudios));

            // PDFs
            formData.append('pdf_exist', existingpostPdfs.length > 0);
            formData.append('new_pdf_exist', postPdfsData.length > 0);
            formData.append('old_pdfs', JSON.stringify(existingpostPdfs));
            formData.append('news_pdf_names', JSON.stringify(postPdfNames));

            postAudioFile.forEach((audio, index) => {
                formData.append(`audio-${index}`, audio);
            });
            postMediaFile.forEach((media, index) => {
                formData.append(`media-${index}`, media);
            });
            postPdfsData.forEach((pdf, index) => {
                formData.append(`docs-${index}`, pdf);
            });

            const { data } = await axios.post(submitUrl, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                onUploadProgress: (progressEvent) => {
                    const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    setUploadProgress(progress);
                }
            });

            if (data.success) {
                if (news) {
                    setNewsList((item) => {
                        return item.map((itm) => {
                            if (itm.news_id === news.news_id) {
                                return data.news;
                            }
                            return itm;
                        });
                    });
                } else {
                    setNewsList((newsItems) => [data.news, ...newsItems]);
                }
                // if (showSnack) {
                //     showSnack(false, data.message);
                // }
                toast.success(data.message);
                handleClose();
            }
        } catch (error) {
            console.error('Error submitting news:', error);
            dispatch(activeLoader(false));
            if (showSnack) {
                showSnack(true, 'Failed to submit news. Please try again.');
            }
        } finally {
            setProcessing(false);
            setUploadProgress(0);
        }
    };

    useEffect(() => {
        const handleEsc = (event) => {
            if (event.keyCode === 27) {
                handleClose();
            }
        };

        window.addEventListener('keydown', handleEsc);
        return () => window.removeEventListener('keydown', handleEsc);
    }, [handleClose]);

    // Ensure modal reflects latest props when reopened without full page reload
    useEffect(() => {
        const isValid = (v) => typeof v === 'string' && v.trim() !== '';

        setText(content || '');

        setExistingPostImages((news?.image || []).filter(isValid));
        setExistingpostAudios((news?.audio || []).filter(isValid));
        setExistingpostPdfs((news?.files || []).filter(isValid));
        setExistingpostVideos((news?.video || []).filter(isValid));

        setOpenImageUploader(Boolean(news?.image?.length || news?.video?.length));
        setOpenPdfUploader(Boolean(news?.files?.length));
        setOpenAudioUploader(Boolean(news?.audio?.length));

        // Clear any newly added yet-unsent files when switching the item being edited
        setPostImages([]);
        setPostAudios([]);
        setPostPdfs([]);
        setPostPdfNames([]);
        setPostMediaData([]);
        setPostaudiosData([]);
        setPostPdfsData([]);
        setPostAudioFile([]);
        setPostMediaFile([]);
        setValidatorMessage([]);
        setUploadProgress(0);
        setProcessing(false);
    }, [news, content]);

    useEffect(() => {
        if (text && text !== '') {
            setValidatorMessage((prev) => prev.filter((item) => item.field !== 'content'));
        }
    }, [text]);

    return (
        <Box
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                backdropFilter: 'blur(4px)',
                zIndex: 1000
            }}
        >
            <Card
                sx={{
                    width: { xs: '95%', md: '700px' },
                    maxHeight: '90vh',
                    position: 'relative',
                    borderRadius: '12px',
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
                    backgroundColor: 'white'
                }}
            >
                <CardContent
                    sx={{
                        p: 3,
                        maxHeight: '85vh',
                        overflowY: 'auto',
                        '&::-webkit-scrollbar': {
                            display: 'none'
                        },
                        scrollbarWidth: 'none',
                        msOverflowStyle: 'none'
                    }}
                >
                    {/* Header */}
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <FiEdit3 size={20} color={theme.palette.primary.main} />
                            <Typography color="primary" sx={{ fontWeight: 600, fontSize: '1.1rem' }}>
                                {title} News
                            </Typography>
                        </Box>
                        <IconButton
                            onClick={handleClose}
                            sx={{
                                color: 'text.secondary',
                                bgcolor: 'grey.100',
                                borderRadius: '50%',
                                '&:hover': { bgcolor: 'grey.300' }
                            }}
                        >
                            <FiX size={18} />
                        </IconButton>
                    </Box>

                    {/* Text Input */}
                    <Box sx={{ mb: 3, position: 'relative' }}>
                        <textarea
                            ref={textInput}
                            placeholder="Write your news..."
                            value={text}
                            onChange={(e) => {
                                setText(e.target.value);
                                setValidatorMessage((prev) => prev.filter((item) => item.field !== 'content'));
                            }}
                            style={{
                                width: '100%',
                                minHeight: '120px',
                                padding: '16px',
                                border: '1px solid #E2E8F0',
                                borderRadius: '8px',
                                resize: 'vertical',
                                fontFamily: 'inherit',
                                fontSize: '1rem',
                                background: '#F8FAFC',
                                outline: 'none',
                                '&:focus': {
                                    borderColor: theme.palette.primary.main
                                }
                            }}
                        />

                        {validatorMessage.find((error) => error.field === 'content') && (
                            <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>
                                {validatorMessage.find((error) => error.field === 'content').message}
                            </Typography>
                        )}
                    </Box>

                    {/* Media Options */}
                    <Box sx={{ mb: 3 }}>
                        <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                            Add to your news
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                            <Button
                                variant={openImageUploader ? 'contained' : 'outlined'}
                                startIcon={<FiImage size={16} />}
                                onClick={() => {
                                    setOpenImageUploader(!openImageUploader);
                                    setOpenAudioUploader(false);
                                    setOpenPdfUploader(false);
                                    if (!openImageUploader) {
                                        setTimeout(() => imageInput.current?.click(), 100);
                                    }
                                }}
                                sx={{
                                    textTransform: 'none',
                                    fontSize: '0.875rem',
                                    borderRadius: '8px'
                                }}
                            >
                                Photos/Videos
                            </Button>
                            <Button
                                variant={openAudioUploader ? 'contained' : 'outlined'}
                                startIcon={<FiMic size={16} />}
                                onClick={() => {
                                    setOpenAudioUploader(!openAudioUploader);
                                    setOpenPdfUploader(false);
                                    setOpenImageUploader(false);
                                    if (!openAudioUploader) {
                                        setTimeout(() => audioInput.current?.click(), 100);
                                    }
                                }}
                                sx={{
                                    textTransform: 'none',
                                    fontSize: '0.875rem',
                                    borderRadius: '8px'
                                }}
                            >
                                Audio
                            </Button>
                            <Button
                                variant={openPdfUploader ? 'contained' : 'outlined'}
                                startIcon={<FiFile size={16} />}
                                onClick={() => {
                                    setOpenPdfUploader(!openPdfUploader);
                                    setOpenAudioUploader(false);
                                    setOpenImageUploader(false);
                                    if (!openPdfUploader) {
                                        setTimeout(() => pdfInput.current?.click(), 100);
                                    }
                                }}
                                sx={{
                                    textTransform: 'none',
                                    fontSize: '0.875rem',
                                    borderRadius: '8px'
                                }}
                            >
                                Documents
                            </Button>
                        </Box>
                    </Box>

                    {/* Media Upload Sections */}
                    <Box sx={{ mb: 3 }}>
                        {/* Images/Videos */}
                        {(openImageUploader || postImages.length > 0 || existingpostImages.length > 0 || existingpostVideos.length > 0) && (
                            <Box sx={{ mb: 3 }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
                                    Photos & Videos
                                </Typography>

                                {/* Existing Images */}
                                {existingpostImages.length > 0 && (
                                    <Box sx={{ mb: 2 }}>
                                        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                                            Existing Images
                                        </Typography>
                                        <Box
                                            sx={{
                                                display: 'grid',
                                                gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                                                gap: 2
                                            }}
                                        >
                                            {existingpostImages.map((image, index) => (
                                                <Box
                                                    key={`existing-img-${index}`}
                                                    sx={{
                                                        position: 'relative',
                                                        borderRadius: '8px',
                                                        overflow: 'hidden',
                                                        backgroundColor: '#F8FAFC',
                                                        border: '1px solid #E2E8F0',
                                                        '&:hover .delete-button': {
                                                            opacity: 1
                                                        }
                                                    }}
                                                >
                                                    <img
                                                        src={image}
                                                        alt="existing"
                                                        style={{
                                                            width: '100%',
                                                            height: '150px',
                                                            objectFit: 'cover'
                                                        }}
                                                    />
                                                    <IconButton
                                                        className="delete-button"
                                                        onClick={() => removeExistingImage(index)}
                                                        sx={{
                                                            position: 'absolute',
                                                            top: 4,
                                                            right: 4,
                                                            opacity: 0,
                                                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                                            color: 'error.main',
                                                            '&:hover': { backgroundColor: 'error.lighter' },
                                                            transition: 'all 0.2s ease'
                                                        }}
                                                    >
                                                        <FiTrash2 size={16} />
                                                    </IconButton>
                                                </Box>
                                            ))}
                                        </Box>
                                    </Box>
                                )}

                                {/* Existing Videos */}
                                {existingpostVideos.length > 0 && (
                                    <Box sx={{ mb: 2 }}>
                                        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                                            Existing Videos
                                        </Typography>
                                        <Box
                                            sx={{
                                                display: 'grid',
                                                gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                                                gap: 2
                                            }}
                                        >
                                            {existingpostVideos.map((video, index) => (
                                                <Box
                                                    key={`existing-video-${index}`}
                                                    sx={{
                                                        position: 'relative',
                                                        borderRadius: '8px',
                                                        overflow: 'hidden',
                                                        backgroundColor: '#F8FAFC',
                                                        border: '1px solid #E2E8F0',
                                                        '&:hover .delete-button': {
                                                            opacity: 1
                                                        }
                                                    }}
                                                >
                                                    <video
                                                        src={video}
                                                        controls
                                                        style={{
                                                            width: '100%',
                                                            height: '150px',
                                                            objectFit: 'cover'
                                                        }}
                                                    />
                                                    <IconButton
                                                        className="delete-button"
                                                        onClick={() => removeExistingVideo(index)}
                                                        sx={{
                                                            position: 'absolute',
                                                            top: 4,
                                                            right: 4,
                                                            opacity: 0,
                                                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                                            color: 'error.main',
                                                            '&:hover': { backgroundColor: 'error.lighter' },
                                                            transition: 'all 0.2s ease'
                                                        }}
                                                    >
                                                        <FiTrash2 size={16} />
                                                    </IconButton>
                                                </Box>
                                            ))}
                                        </Box>
                                    </Box>
                                )}

                                {/* New Images/Videos */}
                                {postImages.length > 0 ? (
                                    <Box sx={{ mb: 2 }}>
                                        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                                            New Files
                                        </Typography>
                                        <Box
                                            sx={{
                                                display: 'grid',
                                                gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                                                gap: 2,
                                                mb: 2
                                            }}
                                        >
                                            {postImages.map((image, index) => (
                                                <Box
                                                    key={`new-img-${index}`}
                                                    sx={{
                                                        position: 'relative',
                                                        borderRadius: '8px',
                                                        overflow: 'hidden',
                                                        backgroundColor: '#F8FAFC',
                                                        border: '1px solid #E2E8F0',
                                                        '&:hover .delete-button': {
                                                            opacity: 1
                                                        }
                                                    }}
                                                >
                                                    {postMediaData[index]?.split(';base64')[0].split(':')[1].split('/')[0] === 'image' ? (
                                                        <img
                                                            src={image}
                                                            alt="uploaded"
                                                            style={{
                                                                width: '100%',
                                                                height: '150px',
                                                                objectFit: 'cover'
                                                            }}
                                                        />
                                                    ) : (
                                                        <video
                                                            src={image}
                                                            controls
                                                            style={{
                                                                width: '100%',
                                                                height: '150px',
                                                                objectFit: 'cover'
                                                            }}
                                                        />
                                                    )}
                                                    <IconButton
                                                        className="delete-button"
                                                        onClick={() => removeMediaFile(index)}
                                                        sx={{
                                                            position: 'absolute',
                                                            top: 4,
                                                            right: 4,
                                                            opacity: 0,
                                                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                                            color: 'error.main',
                                                            '&:hover': { backgroundColor: 'error.lighter' },
                                                            transition: 'all 0.2s ease'
                                                        }}
                                                    >
                                                        <FiTrash2 size={16} />
                                                    </IconButton>
                                                </Box>
                                            ))}
                                        </Box>
                                        <Button
                                            variant="outlined"
                                            startIcon={<FiPlus size={16} />}
                                            onClick={() => imageInput.current?.click()}
                                            sx={{ textTransform: 'none', borderRadius: '8px' }}
                                        >
                                            Add More Photos/Videos
                                        </Button>
                                    </Box>
                                ) : (
                                    <Box
                                        onClick={() => imageInput.current?.click()}
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            p: 4,
                                            borderRadius: '8px',
                                            backgroundColor: '#F8FAFC',
                                            border: '1px dashed #CBD5E1',
                                            cursor: 'pointer',
                                            '&:hover': {
                                                backgroundColor: '#F1F5F9',
                                                borderColor: '#94A3B8'
                                            },
                                            transition: 'all 0.2s ease'
                                        }}
                                    >
                                        <RiUploadCloud2Line size={32} color={theme.palette.primary.main} />
                                        <Typography color="primary" sx={{ mt: 1, fontWeight: 500 }}>
                                            Click to upload photos or videos
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                        )}

                        {/* Audio Files */}
                        {(openAudioUploader || postAudioFile.length > 0 || existingpostAudios.length > 0) && (
                            <Box sx={{ mb: 3 }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
                                    Audio Files
                                </Typography>

                                {/* Existing Audio */}
                                {existingpostAudios.length > 0 && (
                                    <Box sx={{ mb: 2 }}>
                                        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                                            Existing Audio Files
                                        </Typography>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                            {existingpostAudios.map((audio, index) => (
                                                <Box
                                                    key={`existing-audio-${index}`}
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        p: 2,
                                                        borderRadius: '8px',
                                                        backgroundColor: '#F8FAFC',
                                                        border: '1px solid #E2E8F0',
                                                        '&:hover': {
                                                            backgroundColor: '#F1F5F9',
                                                            borderColor: '#CBD5E1'
                                                        },
                                                        transition: 'all 0.2s ease'
                                                    }}
                                                >
                                                    <FiMic size={20} color={theme.palette.primary.main} />
                                                    <Box sx={{ ml: 2, flex: 1 }}>
                                                        <audio controls style={{ width: '100%' }}>
                                                            <source
                                                                src={`${process.env.REACT_APP_BACKEND_URL}/Uploads/${user.user_id}/News/${news.news_id}/${audio}`}
                                                                type="audio/mpeg"
                                                            />
                                                        </audio>
                                                    </Box>
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => removeExistingAudio(index)}
                                                        sx={{
                                                            color: 'text.secondary',
                                                            '&:hover': { color: 'error.main' }
                                                        }}
                                                    >
                                                        <FiTrash2 size={16} />
                                                    </IconButton>
                                                </Box>
                                            ))}
                                        </Box>
                                    </Box>
                                )}

                                {/* New Audio */}
                                {postAudioFile.length > 0 ? (
                                    <Box sx={{ mb: 2 }}>
                                        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                                            New Audio Files
                                        </Typography>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 2 }}>
                                            {postAudioFile.map((audio, index) => (
                                                <Box
                                                    key={`new-audio-${index}`}
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        p: 2,
                                                        borderRadius: '8px',
                                                        backgroundColor: '#F8FAFC',
                                                        border: '1px solid #E2E8F0',
                                                        '&:hover': {
                                                            backgroundColor: '#F1F5F9',
                                                            borderColor: '#CBD5E1'
                                                        },
                                                        transition: 'all 0.2s ease'
                                                    }}
                                                >
                                                    <FiMic size={20} color={theme.palette.primary.main} />
                                                    <Typography sx={{ ml: 2, flex: 1, fontSize: '0.875rem' }}>{audio.name}</Typography>
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => removeAudioFile(index)}
                                                        sx={{
                                                            color: 'text.secondary',
                                                            '&:hover': { color: 'error.main' }
                                                        }}
                                                    >
                                                        <FiTrash2 size={16} />
                                                    </IconButton>
                                                </Box>
                                            ))}
                                        </Box>
                                        <Button
                                            variant="outlined"
                                            startIcon={<FiPlus size={16} />}
                                            onClick={() => audioInput.current?.click()}
                                            sx={{ textTransform: 'none', borderRadius: '8px' }}
                                        >
                                            Add More Audio Files
                                        </Button>
                                    </Box>
                                ) : (
                                    <Box
                                        onClick={() => audioInput.current?.click()}
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            p: 4,
                                            borderRadius: '8px',
                                            backgroundColor: '#F8FAFC',
                                            border: '1px dashed #CBD5E1',
                                            cursor: 'pointer',
                                            '&:hover': {
                                                backgroundColor: '#F1F5F9',
                                                borderColor: '#94A3B8'
                                            },
                                            transition: 'all 0.2s ease'
                                        }}
                                    >
                                        <FiMic size={32} color={theme.palette.primary.main} />
                                        <Typography color="primary" sx={{ mt: 1, fontWeight: 500 }}>
                                            Click to upload audio files
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                        )}

                        {/* Documents */}
                        {(openPdfUploader || postPdfs.length > 0 || existingpostPdfs.length > 0) && (
                            <Box sx={{ mb: 3 }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
                                    Documents
                                </Typography>

                                {/* Existing Documents */}
                                {existingpostPdfs.length > 0 && (
                                    <Box sx={{ mb: 2 }}>
                                        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                                            Existing Documents
                                        </Typography>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                            {existingpostPdfs.map((pdf, index) => {
                                                const source = pdf.split('/')[1];
                                                const filename = pdf.split('/')[0];
                                                return (
                                                    <Box
                                                        key={`existing-pdf-${index}`}
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            p: 2,
                                                            borderRadius: '8px',
                                                            backgroundColor: '#F8FAFC',
                                                            border: '1px solid #E2E8F0',
                                                            '&:hover': {
                                                                backgroundColor: '#F1F5F9',
                                                                borderColor: '#CBD5E1'
                                                            },
                                                            transition: 'all 0.2s ease'
                                                        }}
                                                    >
                                                        <FiFile size={20} color={theme.palette.primary.main} />
                                                        <Typography
                                                            sx={{
                                                                ml: 2,
                                                                flex: 1,
                                                                fontSize: '0.875rem',
                                                                cursor: 'pointer',
                                                                '&:hover': { color: 'primary.main' }
                                                            }}
                                                            onClick={() => {
                                                                window.open(
                                                                    `${process.env.REACT_APP_BACKEND_URL}/Uploads/${user.user_id}/News/${news.news_id}/${source}`,
                                                                    '_blank'
                                                                );
                                                            }}
                                                        >
                                                            {filename}
                                                        </Typography>
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => removeExistingPdf(index)}
                                                            sx={{
                                                                color: 'text.secondary',
                                                                '&:hover': { color: 'error.main' }
                                                            }}
                                                        >
                                                            <FiTrash2 size={16} />
                                                        </IconButton>
                                                    </Box>
                                                );
                                            })}
                                        </Box>
                                    </Box>
                                )}

                                {/* New Documents */}
                                {postPdfs.length > 0 ? (
                                    <Box sx={{ mb: 2 }}>
                                        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                                            New Documents
                                        </Typography>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 2 }}>
                                            {postPdfs.map((pdf, index) => (
                                                <Box
                                                    key={`new-pdf-${index}`}
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        p: 2,
                                                        borderRadius: '8px',
                                                        backgroundColor: '#F8FAFC',
                                                        border: '1px solid #E2E8F0',
                                                        '&:hover': {
                                                            backgroundColor: '#F1F5F9',
                                                            borderColor: '#CBD5E1'
                                                        },
                                                        transition: 'all 0.2s ease'
                                                    }}
                                                >
                                                    <FiFile size={20} color={theme.palette.primary.main} />
                                                    <Typography
                                                        sx={{
                                                            ml: 2,
                                                            flex: 1,
                                                            fontSize: '0.875rem',
                                                            cursor: 'pointer',
                                                            '&:hover': { color: 'primary.main' }
                                                        }}
                                                        onClick={() => window.open(pdf, '_blank')}
                                                    >
                                                        {postPdfNames[index]}
                                                    </Typography>
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => removePdfFile(index)}
                                                        sx={{
                                                            color: 'text.secondary',
                                                            '&:hover': { color: 'error.main' }
                                                        }}
                                                    >
                                                        <FiTrash2 size={16} />
                                                    </IconButton>
                                                </Box>
                                            ))}
                                        </Box>
                                        <Button
                                            variant="outlined"
                                            startIcon={<FiPlus size={16} />}
                                            onClick={() => pdfInput.current?.click()}
                                            sx={{ textTransform: 'none', borderRadius: '8px' }}
                                        >
                                            Add More Documents
                                        </Button>
                                    </Box>
                                ) : (
                                    <Box
                                        onClick={() => pdfInput.current?.click()}
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            p: 4,
                                            borderRadius: '8px',
                                            backgroundColor: '#F8FAFC',
                                            border: '1px dashed #CBD5E1',
                                            cursor: 'pointer',
                                            '&:hover': {
                                                backgroundColor: '#F1F5F9',
                                                borderColor: '#94A3B8'
                                            },
                                            transition: 'all 0.2s ease'
                                        }}
                                    >
                                        <FiFile size={32} color={theme.palette.primary.main} />
                                        <Typography color="primary" sx={{ mt: 1, fontWeight: 500 }}>
                                            Click to upload documents
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                        )}
                    </Box>

                    {/* Progress Bar */}
                    {uploadProgress > 0 && (
                        <Box sx={{ mb: 3 }}>
                            <LinearProgress
                                variant="determinate"
                                value={uploadProgress}
                                sx={{
                                    borderRadius: '4px',
                                    height: '8px'
                                }}
                            />
                            <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 1 }}>
                                Uploading... {uploadProgress}%
                            </Typography>
                        </Box>
                    )}

                    {/* Submit Button */}
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            variant="contained"
                            onClick={submitRequest}
                            disabled={processing || uploadProgress > 0}
                            sx={{
                                borderRadius: '8px',
                                textTransform: 'none',
                                fontSize: '1rem',
                                fontWeight: 600
                            }}
                        >
                            {processing || uploadProgress > 0 ? 'Publishing...' : news ? 'Update News' : 'Publish News'}
                        </Button>
                    </Box>

                    {/* Hidden file inputs */}
                    <input
                        ref={imageInput}
                        type="file"
                        accept="image/*,video/*"
                        onChange={convertMedia}
                        style={{ display: 'none' }}
                        multiple
                    />
                    <input ref={audioInput} type="file" accept="audio/*" onChange={convertAudio} style={{ display: 'none' }} multiple />
                    <input
                        ref={pdfInput}
                        type="file"
                        accept=".pdf,.xlsx,.doc,.docx"
                        onChange={convertPdf}
                        style={{ display: 'none' }}
                        multiple
                    />
                </CardContent>
            </Card>
        </Box>
    );
};

export default NewsModal;
